export const FT_HEADER_CALL_BACK_ENABLED = 'ldt_hdms_header_callmeback';
export const FT_HEADER_CHAT_ENABLED = 'ldt_hdms_header_livechat';
export const FT_HEADER_SEND_MESSAGE_ENABLED = 'ldt_hdms_header_sendmessage';
export const FT_BARCODE_SCANNING_MODAL = 'ldt_barcode_scanning_modal';
